import {
  deleteAuthMethod,
  getAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";
import { leadCustomFieldDefinitions } from "../constant/Constant";

const normalizeLeadCustomFieldDefinition = (field = {}) => ({
  ...field,
  isActive:
    field?.isActive !== undefined
      ? field.isActive
      : field?.active !== undefined
        ? field.active
        : true,
});

const normalizeLeadCustomFieldDefinitions = (data) => {
  if (Array.isArray(data)) {
    return data.map(normalizeLeadCustomFieldDefinition);
  }

  if (Array.isArray(data?.content)) {
    return data.content.map(normalizeLeadCustomFieldDefinition);
  }

  return [];
};

const getLeadCustomFieldDefinitionPayload = (payload = {}) => {
  const { active, ...restPayload } = payload;

  return {
    ...restPayload,
    isActive:
      payload?.isActive !== undefined
        ? payload.isActive
        : active !== undefined
          ? active
          : true,
  };
};

export const getLeadCustomFieldDefinitions = (query = "") => () => {
  const apiUrl = query
    ? `${leadCustomFieldDefinitions}?${query}`
    : leadCustomFieldDefinitions;

  return getAuthMethod(apiUrl)
    .then((res) => normalizeLeadCustomFieldDefinitions(res?.data))
    .catch((err) => err);
};

export const createLeadCustomFieldDefinition = (payload) => () => {
  return postAuthMethod(
    leadCustomFieldDefinitions,
    getLeadCustomFieldDefinitionPayload(payload),
  )
    .then((res) => res)
    .catch((err) => err);
};

export const updateLeadCustomFieldDefinition = (payload) => () => {
  return putAuthMethod(
    leadCustomFieldDefinitions,
    payload?.id,
    getLeadCustomFieldDefinitionPayload(payload),
  )
    .then((res) => res)
    .catch((err) => err);
};

export const deleteLeadCustomFieldDefinition = (id) => () => {
  return deleteAuthMethod(`${leadCustomFieldDefinitions}/${id}`)
    .then((res) => res)
    .catch((err) => err);
};
